import appVariablePlans from "../../views/appPlans/variables.html";
import constants from "../../core/constants";
import { getState } from "../../core/utils";

function urlsConfig($stateProvider) {
  "ngInject";

  const base = "variable-plans";
  const params = ["page", "limit"];

  $stateProvider.state("variableplans", {
    url: getState(base, params),
    parent: "app",
    views: {
      view: {
        template: appVariablePlans,
      },
    },
    reloadOnSearch: false,
    data: { title: "VariablePlans" + constants.titleBase },
  });
}

export default urlsConfig;



// WEBPACK FOOTER //
// ./src/pages/variablePlans/variablePlans.urls.js